module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab17",
      "name": "hres31x-tab17"
    }
  }, [_vm._l((_vm.detail.tableDocument.rows), function(value, index) {
    return [_c('detail-template', {
      attrs: {
        "index": index,
        "labels": _vm.labels,
        "detail": _vm.detail
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('div', {
              staticClass: "sub-topic-box color-skin",
              attrs: {
                "slot": "head"
              },
              on: {
                "click": function($event) {
                  _vm.toggleDisp()
                }
              },
              slot: "head"
            }, [_c('i', {
              staticClass: "fa fa-file-o icon-sub-topic",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "sub-topic"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['10']) + " ( " + _vm._s(_vm.labels['HRES31XC16']['20']) + "  " + _vm._s(index + 1) + " )")])]), _vm._v(" "), _c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.topicDisp),
                expression: "topicDisp"
              }],
              staticClass: "data-pers-box",
              attrs: {
                "slot": "body"
              },
              slot: "body"
            }, [_c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['30']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.typdoc))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['40']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.namdoc))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['50']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(_vm.setDateOutput(value.dterecv)))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['60']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(_vm.setDateOutput(value.dtedocen)))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['70']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.numdoc))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['80']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [(value.filedoc === '-') ? [_vm._v("\n                -\n              ")] : [_c('a', {
              attrs: {
                "href": value.path_filedoc,
                "target": "_blank"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-paperclip"
            }), _vm._v(" " + _vm._s(value.filedoc))])]], 2)]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC16']['90']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.desnote))])])])])
          
        },
        staticRenderFns: []
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15679127!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab17.vue
// module id = 3583
// module chunks = 1